import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21fdbade"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  colspan: "10",
  class: "containers"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "集装箱信息", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      _hoisted_2,
      (_ctx.showSealNumbers && !_ctx.departurePortContainer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.Containers, (it, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("span", null, _toDisplayString(it.ContainerTypeLabel?.contains("/")
              ? `${it.ContainerTypeLabel?.substring(
                  0,
                  it.ContainerTypeLabel.indexOf("/")
                )}×${it.Quantity}`
              : `${it.ContainerTypeLabel}×${it.Quantity}`), 1),
                ((it.SealNumbers?.length ?? 0) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, " 箱封号："))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.SealNumbers, (item, i) => {
                  return (_openBlock(), _createElementBlock("span", { key: i }, "【" + _toDisplayString(item.ContainerNo ?? "暂无数据") + "/" + _toDisplayString(item.SealNo ?? "暂无数据") + "】", 1))
                }), 128))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.showSealNumbers && _ctx.departurePortContainer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.Data.Containers, (it, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createElementVNode("span", null, _toDisplayString(it.ContainerTypeLabel?.contains("/")
              ? `${it.ContainerTypeLabel?.substring(
                  0,
                  it.ContainerTypeLabel.indexOf("/")
                )}×${it.Quantity}`
              : `${it.ContainerTypeLabel}×${it.Quantity}`), 1),
                ((it.DeparturePortContainerSealNumbers?.length ?? 0) > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " 箱封号："))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(it.DeparturePortContainerSealNumbers, (item, i) => {
                  return (_openBlock(), _createElementBlock("span", { key: i }, "【" + _toDisplayString(item.ContainerNo ?? "暂无数据") + "/" + _toDisplayString(item.SealNo ?? "暂无数据") + "】", 1))
                }), 128))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!_ctx.showSealNumbers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.form.Data.Containers.map((it) =>
            it.ContainerTypeLabel?.contains("/")
              ? `${it.ContainerTypeLabel?.substring(
                  0,
                  it.ContainerTypeLabel.indexOf("/")
                )}×${it.Quantity}`
              : `${it.ContainerTypeLabel}×${it.Quantity}`
          ).join("+")), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}